import {
    Box,
    Button,
    FormControl,
    FormHelperText,
    IconButton,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import ArrowDropDownCircleIcon from "@material-ui/icons/ArrowDropDownCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { Controller, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ErrorMsg from "../../../component/ErrorMsg/ErrorMsg";

export default function DailyStatistics({
    classes,
    control,
    register,
    errors,
    jobIndex,
    setValue,
    getValues,
    defaultValues,
    reviewerList,
}) {
    const { t, i18n } = useTranslation();

    const { fields, remove, append } = useFieldArray({
        control,
        name: `job.${jobIndex}.reviewerList`,
    });

    return (
        <Box mt={8}>
            <TableContainer component={Paper}>
                <Table stickyHeader arial-label="subject table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" width={"2%"}></TableCell>
                            <TableCell align="center" width={"30%"}>
                                <b>{t("common.portal.post")}</b>
                            </TableCell>
                            {/* <TableCell align="center" width={"20%"}>
                                <b>{t("Form101.label.name")}</b>
                            </TableCell> */}
                            {/* <TableCell align="center" width={"50%"}>
                                <b>{t("Form101.label.email")}</b>
                            </TableCell> */}
                            <TableCell align="center" width={"10%"}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {fields.map((reviewer, reviewerIndex) => {
                            return (
                                <TableRow key={reviewer.id}>
                                    <TableCell
                                        width={"2%"}
                                        align="center"
                                        className={classes.subjectRow}
                                    >
                                        {reviewerIndex !== 0 && (
                                            <IconButton
                                                color="primary"
                                                onClick={() => {
                                                    const renderReviewerList =
                                                        fields;
                                                    const reviewerListData =
                                                        getValues(
                                                            `job.${jobIndex}.reviewerList`
                                                        );
                                                    reviewerListData[
                                                        reviewerIndex - 1
                                                    ] =
                                                        renderReviewerList[
                                                            reviewerIndex
                                                        ];
                                                    reviewerListData[
                                                        reviewerIndex
                                                    ] =
                                                        renderReviewerList[
                                                            reviewerIndex - 1
                                                        ];
                                                    setValue(
                                                        `job.${jobIndex}.reviewerList`,
                                                        reviewerListData
                                                    );
                                                }}
                                            >
                                                <ArrowDropDownCircleIcon
                                                    style={{
                                                        transform:
                                                            "rotate(180deg)",
                                                    }}
                                                    fontSize="small"
                                                />
                                            </IconButton>
                                        )}
                                        {reviewerIndex !==
                                            fields.length - 1 && (
                                            <IconButton
                                                color="primary"
                                                onClick={() => {
                                                    const renderReviewerList =
                                                        fields;
                                                    const reviewerListData =
                                                        getValues(
                                                            `job.${jobIndex}.reviewerList`
                                                        );
                                                    reviewerListData[
                                                        reviewerIndex + 1
                                                    ] =
                                                        renderReviewerList[
                                                            reviewerIndex
                                                        ];
                                                    reviewerListData[
                                                        reviewerIndex
                                                    ] =
                                                        renderReviewerList[
                                                            reviewerIndex + 1
                                                        ];
                                                    setValue(
                                                        `job.${jobIndex}.reviewerList`,
                                                        reviewerListData
                                                    );
                                                }}
                                            >
                                                <ArrowDropDownCircleIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                    <TableCell
                                        width={"30%"}
                                        align="center"
                                        className={classes.subjectRow}
                                    >
                                        <FormControl
                                            className={classes.reviewerSelect}
                                        >
                                            <Controller
                                                control={control}
                                                name={`job.${jobIndex}.reviewerList.${reviewerIndex}.post`}
                                                defaultValue={
                                                    defaultValues?.job?.[
                                                        jobIndex
                                                    ]?.reviewerList?.[
                                                        reviewerIndex
                                                    ]?.post
                                                }
                                                render={({ field }) => (
                                                    <Select
                                                        displayEmpty
                                                        value={field.value}
                                                        onChange={(e) => {
                                                            const value =
                                                                e.target.value;
                                                            const reviewer =
                                                                reviewerList.find(
                                                                    (
                                                                        reviewer
                                                                    ) =>
                                                                        reviewer?.post ===
                                                                        value
                                                                );
                                                            field.onChange(
                                                                value
                                                            );
                                                            // setValue(
                                                            //     `job.${jobIndex}.reviewerList.${reviewerIndex}.name`,
                                                            //     reviewer.name
                                                            // );
                                                            // setValue(
                                                            //     `job.${jobIndex}.reviewerList.${reviewerIndex}.email`,
                                                            //     reviewer.email
                                                            // );
                                                        }}
                                                        inputProps={{
                                                            "aria-labelledby": `job.${jobIndex}.reviewerList.${reviewerIndex}.post`,
                                                            id: `job.${jobIndex}.reviewerList.${reviewerIndex}.post`,
                                                        }}
                                                    >
                                                        {reviewerList.map(
                                                            (reviewer) => (
                                                                <MenuItem
                                                                    key={
                                                                        reviewer.post
                                                                    }
                                                                    value={
                                                                        reviewer.post
                                                                    }
                                                                    style={{
                                                                        display:
                                                                            reviewer.post ===
                                                                            field.value
                                                                                ? "none"
                                                                                : "block",
                                                                    }}
                                                                >
                                                                    {
                                                                        reviewer.post
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </Select>
                                                )}
                                            />
                                            <FormHelperText>
                                                <ErrorMsg
                                                    message={
                                                        errors.job?.[jobIndex]
                                                            ?.reviewerList?.[
                                                            reviewerIndex
                                                        ]?.post?.message
                                                    }
                                                />
                                            </FormHelperText>
                                        </FormControl>
                                    </TableCell>
                                    {/* <TableCell
                                        width={"25%"}
                                        align="center"
                                        className={classes.subjectRow}
                                    >
                                        <CustomTextField
                                            inputProps={{
                                                ...register(
                                                    `job.${jobIndex}.reviewerList.${reviewerIndex}.name`
                                                ),
                                                autoComplete: "off",
                                            }}
                                            disabled
                                            fullWidth
                                        />
                                    </TableCell> */}
                                    {/* <TableCell
                                        width={"50%"}
                                        align="center"
                                        className={classes.subjectRow}
                                    >
                                        <CustomTextField
                                            inputProps={{
                                                ...register(
                                                    `job.${jobIndex}.reviewerList.${reviewerIndex}.email`
                                                ),
                                                autoComplete: "off",
                                            }}
                                            disabled
                                            fullWidth
                                        />
                                    </TableCell> */}
                                    <TableCell
                                        width={"10%"}
                                        align="center"
                                        className={classes.subjectRow}
                                    >
                                        <IconButton
                                            color="primary"
                                            onClick={() => {
                                                remove(reviewerIndex);
                                            }}
                                        >
                                            <RemoveCircleIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box mt={6} style={{ textAlign: "right" }}>
                <Button
                    onClick={() => {
                        append(
                            {
                                post: "",
                                name: "",
                                email: "",
                            },
                            { shouldFocus: false }
                        );
                    }}
                    variant="contained"
                    color="primary"
                    aria-label="add"
                >
                    {t("common.button.append")}
                </Button>
            </Box>
        </Box>
    );
}
